import styled from 'styled-components'

export const Label = styled.label`
  font-size: 14px;
  display: block;
  margin: 0 0 4px;
`
